export default __webpack_public_path__ + "static/raimond-800f0b77e371624d91a34b83b4c76581.jpg";